"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@material-ui/core/styles");

var _Divider = _interopRequireDefault(require("@eig-builder/core-ui/Divider"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _Menu = _interopRequireDefault(require("@eig-builder/core-ui/Menu"));

var _MenuItem = _interopRequireDefault(require("@eig-builder/core-ui/MenuItem"));

var _ListItemIcon = _interopRequireDefault(require("@eig-builder/core-ui/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@eig-builder/core-ui/ListItemText"));

var _Avatar = _interopRequireDefault(require("@eig-builder/core-ui/Avatar"));

var _goToHelper = require("@eig-builder/core-utils/helpers/go-to-helper");

var _accountContext = _interopRequireDefault(require("../context/account-context"));

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

var _userBox = _interopRequireDefault(require("./user-box"));

var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  width: 36px;\n  height: 36px;\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var styles = {
  root: {
    flexGrow: 1
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: 0,
    marginRight: 20
  }
};

var UserboxCircle = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
});

var AccountBox = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(AccountBox, _Component);

  var _super = _createSuper(AccountBox);

  function AccountBox() {
    var _this;

    (0, _classCallCheck2["default"])(this, AccountBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      open: false
    };

    _this.toggle = function (event) {
      _this.setState({
        open: !_this.state.open,
        anchorEl: event.currentTarget
      });
    };

    _this.getInitials = function (name) {
      if (name) {
        var letter = name.charAt(0).toUpperCase();
        return letter;
      }

      return '';
    };

    _this.handleOnClick = function (history, item) {
      if (item.isExternal) {
        window.open(item.link, item.target);
        return;
      }

      (0, _goToHelper.goToWithHistory)(history, item.link);
    };

    return _this;
  }

  (0, _createClass2["default"])(AccountBox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var classes = this.props.classes;
      var _this$state = this.state,
          open = _this$state.open,
          anchorEl = _this$state.anchorEl;
      return /*#__PURE__*/_react["default"].createElement(_wrapperContext["default"].Consumer, null, function (wrapperContext) {
        return /*#__PURE__*/_react["default"].createElement(_accountContext["default"].Consumer, null, function (accountContext) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "account-dropdown-box"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            onClick: _this2.toggle
          }, /*#__PURE__*/_react["default"].createElement(UserboxCircle, {
            className: classes.menuButton,
            backgroundColor: _this2.props.backgroundColor,
            onClick: _this2.toggle
          }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
            style: {
              backgroundColor: wrapperContext.userColor
            }
          }, _this2.getInitials(wrapperContext.userFullName)))), _this2.state.open && /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
            id: "account-menu",
            anchorEl: anchorEl,
            open: open,
            onClose: _this2.toggle,
            MenuListProps: {
              style: {
                padding: 0
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_userBox["default"], {
            userFullname: wrapperContext.userFullName,
            userEmail: wrapperContext.userEmail,
            size: 40,
            userColor: wrapperContext.userColor
          }), accountContext.menuItems.map(function (item, index) {
            if (item.hide) {
              return null;
            }

            if ((0, _isBoolean["default"])(item.hideForFreeAccount) && item.hideForFreeAccount && wrapperContext.isFreeAccount) {
              return null;
            } else if ((0, _isBoolean["default"])(item.hideForPaidAccount) && item.hideForPaidAccount && !wrapperContext.isFreeAccount) {
              return null;
            }

            return /*#__PURE__*/_react["default"].createElement("div", {
              key: index
            }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
              className: "account-menu-item",
              button: true,
              onClick: function onClick() {
                return _this2.handleOnClick(wrapperContext.history, item);
              },
              tag: item.tag
            }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
              icon: item.materialIconTag
            })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], null, item.title)), accountContext.menuItems.length - 1 !== index && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null));
          })));
        });
      });
    }
  }]);
  return AccountBox;
}(_react.Component);

AccountBox.contextTypes = {
  router: _propTypes["default"].shape()
};
AccountBox.propTypes = {
  backgroundColor: _propTypes["default"].string,
  classes: _propTypes["default"].object.isRequired
};
AccountBox.defaultProps = {
  backgroundColor: '#26A69A'
};

var _default = (0, _styles.withStyles)(styles)(AccountBox);

exports["default"] = _default;